import React from 'react';
import { ModuleTitleWrapper } from './ModuleTitle.style';

interface ModuleTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  color?: string;
  marginBottom?: string;
}

const ModuleTitle: React.FC<ModuleTitleProps> = ({
  title,
  subtitle,
  color,
  marginBottom = '16px',
}) => {
  return (
    <ModuleTitleWrapper
      data-test="module-title"
      color={color}
      marginBottom={marginBottom}
    >
      <h2 className="title" data-test="module-title-title">
        {title}
      </h2>
      {subtitle && (
        <p className="subtitle" data-test="module-title-subtitle">
          {subtitle}
        </p>
      )}
    </ModuleTitleWrapper>
  );
};

export { ModuleTitle };
